// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    /* Container */
    --ds-radio-container-bg-color: var(--ds-color-grey-indigo-70);
    --ds-radio-container-disabled-bg-color: var(--ds-color-grey-indigo-80);
    --ds-radio-container-border-color: var(--ds-color-grey-indigo-40);
    --ds-radio-container-hover-border-color: var(--ds-color-grey-20);
    /* Radio */
    --ds-radio-input-color: var(--ds-color-grey-10);
    --ds-radio-input-description-color: var(--ds-color-grey-20);
    --ds-radio-input-disabled-color: var(--ds-color-grey-30);
    --ds-radio-input-bg-color: var(--ds-color-grey-indigo-80);
    /* Outline */
    --ds-radio-input-outline-color: var(--ds-color-focus-outline);
    /* Input */
    --ds-radio-selected-fill: var(--ds-color-neon-0);
    --ds-radio-border-color: var(--ds-color-grey-40);
    --ds-radio-hover-border-color: var(--ds-color-grey-20);
    --ds-radio-selected-border-color: var(--ds-color-grey-10);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
